import styled from 'styled-components'
import { device } from '@/common/constants/device'

export default styled.div`
  width: ${({ size }) => `${size || 16}px`};
  height: ${({ size }) => `${size || 16}px`};
  mask-image: ${({ icon, path }) =>
    path
      ? `url(/_next_static${path}${icon}.svg)`
      : `url(/_next_static/icons/${icon}.svg)`};
  mask-size: contain;
  mask-position: center;
  mask-repeat: no-repeat;

  background-color: var(--${({ color }) => color || 'black'});

  @media ${device.tablet} {
    width: ${({ sizeT }) => sizeT && `${sizeT}px`};
    height: ${({ sizeT }) => sizeT && `${sizeT}px`};
  }
`
